module.exports = __webpack_public_path__ + "static/beauty-creative-team-section-9419302552a7127dcc21ee531b3184b8.png";